<template>
    <v-flex xs1 class=" mr-2">
        <v-menu class="myHelpIcon"
                offset-y
                @mousedown="refreshHintWidth"
        >
            <div v-if="$slots.default" @mousedown="refreshHintWidth" slot="activator">
                <v-icon title ="klicken für Infos zum Feld" medium class="mt-3 primary--text" floating @mousedown="refreshHintWidth">help</v-icon>
            </div>
            <div v-else slot="activator">
                <v-icon medium class="mt-3 grey--text" style="opacity: .2" floating >lens</v-icon>
            </div>


            <v-card class="pa-2" v-if="$slots.default">
                <div :style="{textAlign: 'left', width: (midColWidth-140)+'px'}" @click="refreshHintWidth">
                    <!-- breiten-Fix: das PopOver soll immer schmaler ist als die leftCol, damit es links vom Fragezeichen aufpoppt -->
                    <slot>
                    </slot>
                </div>
            </v-card>
        </v-menu>
    </v-flex>
</template>
<!-- _____________________________________________________________________________________________________________________________________________________________ -->
<!-- ############################################################################################################################################################# -->
<script>
  // import _ from 'lodash'

  export default {
    name: 'Rechner-hint-col',
    data () {
      return {
        test: 123,
        leftColWidth: 100,
        midColWidth: 400,
      }
    },
    methods: {
      refreshHintWidth: function () {
        //  console.log("HintCol", this);
        //  window.hc = this;

        //this.leftColWidth = this.$parent.$el.children[0].offsetWidth - 20;
        this.leftColWidth = this.$parent.$el.children[0].offsetWidth - 20;
        this.midColWidth = this.$parent.$el.children[1].offsetWidth - 20;
      },

    },
    props: [],
    computed: {
      testWidth: function () {
        console.log("HintCol of ".this.$parent.name, this);
        window.hc = this;
        return this.$parent.$el.children[0].offsetWidth;
      }
    },
  }
</script>
<!-- ############################################################################################################################################################# -->
<!-- ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯ -->
<style scoped>
    .myHelpIcon{
    margin: 3px 0 0 0;
    }
</style>
